export default __webpack_public_path__ + "static/media/calculatorimg.669bf5cb.png";